import queryString from 'query-string';

const stringify = params =>
  queryString.stringify(params, { arrayFormat: 'repeat' });

export default stringify;
